import { useEffect } from 'react'
import LogoKJ from '../imgs/footer/logo-kJ-min.png'
import AvisoPrivacidad from './AvisoPrivacidad'

const InternalFooter = () => {

  useEffect(() => {
    const queryString = window.location.search;

    const params = new URLSearchParams(queryString);
    const ap = params.get('aviso-privacidad');
    if (ap) {

      const avisoLink = document.querySelector(
        'span[data-bs-target="#avisoPrivacidadModal"]'
      );

      if (avisoLink) {
        avisoLink.click();
      }
    }
  }, [])

  return (
    <>
      <footer className="bg-dark text-white pt-4">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 text-center text-md-start">
              <img src={LogoKJ} width="150" height="150" alt="Logo KJ Logistics" className="img-fluid mb-2" />

              <p className="mt-0">© KJ Logistics. Todos los derechos reservados.</p>
            </div>

            <div className="col-md-6 mb-4  mt-4 text-center text-md-end">
              <div>
                <a href="https://www.facebook.com/profile.php?id=100064372291202" className="text-white me-3"><i className="fab fa-facebook-f"></i></a>
                <a href="https://www.instagram.com/kj_logistics/" className="text-white me-3"><i className="fab fa-instagram"></i></a>
              </div>
              <ul className="list-inline mt-2 footer-link">
                <li className="list-inline-item"><span className="text-white text-decoration-none"
                  data-bs-toggle="modal" data-bs-target="#avisoPrivacidadModal">Aviso de
                  privacidad</span>
                </li>
                <li className="list-inline-item"><span className="text-white text-decoration-none">Términos y
                  Condiciones</span></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      <div className="modal fade" id="avisoPrivacidadModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {<AvisoPrivacidad />}
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default InternalFooter